import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateLot = (resource, id, { lotId, ...values }) => {
  return axios.put(`/api/${resource}/${id}/setup/lots/${lotId}`, values);
};

export const useUpdateLot = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateLot(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Lot successfully updated', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.description || error?.message || 'Some error occured', {
        variant: 'error',
      });
    },
  });
};
